import type { DataOption } from '@/common.types'
import type { SettingsTemplateModel } from '@/shared/generated'

import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getSchemaIntertpretationsList } from '@/shared/components/SchemaInterpretator'
import { Spinner } from '@/shared/components/ui/spinner'
import { SettingsTemplateType } from '@/shared/generated'
import { translateSchemaKeys } from '@/shared/tools/json-schema-utils'

import { useSettingsTemplateInterpretationProps } from '../lib/useSettingsTemplateInterpretationProps'

export function SettingsTemplateGeneratedCardContent({
	template,
}: {
	template: SettingsTemplateModel
}) {
	const { t } = useTranslation()

	const { schema, uiSchema, isLoading } =
		useSettingsTemplateInterpretationProps({ type: template.template_type })
	const interpretation = useMemo(
		() =>
			getSchemaIntertpretationsList({
				schema: translateSchemaKeys(schema?.properties?.body || {}, t),
				data: template.body,
				uiSchema,
			}),
		[schema, template.body, uiSchema]
	)
	const getFieldValue = useCallback(
		(name: string) => {
			const field = interpretation.find(({ key }) => key === name)
			if (field?.resolvedValue) {
				return Array.isArray(field?.resolvedValue)
					? field?.resolvedValue?.map(({ label }) => label).join(', ')
					: (field?.resolvedValue as DataOption)?.label
			} else {
				return field?.currentValue
			}
		},
		[interpretation]
	)
	if (isLoading) {
		return <Spinner />
	}
	if (template.template_type === SettingsTemplateType.Scenario) {
		return (
			<div className='prose-sm flex flex-col space-y-1'>
				<span>
					{t('og_metric_to_grow')}:{' '}
					{getFieldValue('settings.strategy.demand_strategy.target')}
				</span>
				<span>
					{t('og_metric_to_maintain')}:{' '}
					{getFieldValue('settings.strategy.demand_strategy.protect')}
				</span>
				<span>
					{
						(template.body as { pricing_campaigns: string[] }).pricing_campaigns
							.length
					}{' '}
					{t('general_pc')}
				</span>
			</div>
		)
	}

	return (
		<div className='prose-sm flex items-center'>
			<span>-</span>
		</div>
	)
}
